<template>
	<div class="fondoModal">
		<div>
			<div>
				<div class="card">
					<div class="card-header">
						Visualizador de ficheros
						<button type="button" class="close" aria-label="Close" @click="cerrar">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="card-body pt-0 pb-0">
						<div class="row">
							<div class="col bg-light p-3 text-left">
								<div style="display:table;width:100%;">
									<div style="display:table-row">
										<div style="display:table-cell;width:65px;vertical-align:top;">
											<img v-if="fichero.fichero.usuario" :src="fichero.fichero.usuario.avatar" alt="avatar" class="rounded-circle mr-2" style="border:1px solid #e0e0e0;float-left;width:60px;">
										</div>
										<div style="display:table-cell;vertical-align:top;">
											<div style="position:relative;display:inline-block;vertical-align:top;">
												Subido por: <b v-if="fichero.fichero.usuario">{{fichero.fichero.usuario.nombre}}</b> <b v-if="!fichero.fichero.usuario">Desconocido</b>
												<br>
												Tamaño: <b>{{tamano}}</b>
												<br>
												Fecha: <b>{{fichero.fichero.fecha}}</b>
												<br>
												Nombre del fichero: <b>{{fichero.fichero.nombre}}</b>
												<br>
												Duración: <b>{{fichero.fichero.duracion | round(2)}} seg.</b>
												<br>
												Derechos de autor: <b>{{fichero.fichero.musica_autor === 1 ? 'Sí' : 'No'}}</b>
												<button v-if="fichero.fichero.xframe_num" class="mt-2 btn btn-sm" :class="(verAuditor) ? 'btn-info' : 'btn-default'" @click="verAuditor = !verAuditor">
													<span class="fa fa-calendar"></span>
												</button>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="col p-0 bg-info text-white">
								<div v-if="tipoFichero === 'audio'" style="padding: 0;margin:0;position:absolute;display:block;bottom:-5px;left: 0;right: 0;">
									<h3>Reproductor</h3>
									<audio controls="true" autoplay="true" style="width:100%;">
										<source type="audio/mp3" :src="url" />
									</audio>
								</div>
								<div v-if="tipoFichero === 'imagen'">
									<img :src="url" style="position:relative;display:block;width:100%;border: 1px solid #e0e0e0;" alt="Imágen producida">
								</div>
								<div v-if="tipoFichero === 'video'">
									<video :src="url" controls="true" autoplay="true" style="max-width:100%;margin-bottom:-5px;"></video>
								</div>
								<div v-if="tipoFichero === 'desconocido'">
									<h1>Fichero no visualizable</h1>
								</div>
							</div>
						</div>
					</div>
					<div v-if="fichero.fichero.xframe_num && verAuditor" class="mt-4 text-left">
						<div class="bg-warning p-2 mb-3">
							<h3 class="p-0 m-0 pl-3">
								<span class="fa fa-calendar"></span>
								Auditor
							</h3>
						</div>
						<detalles-auditor :idfichero="fichero.fichero.ID_fichero"></detalles-auditor>
					</div>
					<!--
					<div class="card-body">
						<pre>{{fichero}}</pre>
					</div>
					-->
					<div class="card-footer">
						<a :href="url" class="btn btn-sm btn-info">
							<span class="fa fa-download" style="margin-right:3px;"></span>
							Descargar
						</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

import DetallesAuditor from '../auditor/detalles'

export default {
	name: 'reproductor',
	props: ['fichero'],
	components: {
		'detalles-auditor': DetallesAuditor
	},

	data: function () {
		return {
			verAuditor: false
		}
	},

	computed: {
		tipoFichero () {
			if (!this.fichero) {
				return
			}
			const ext = this.fichero.fichero.fichero.split('.').splice(-1, 1)[0].toLowerCase()

			if (ext.match(/(mp3|ogg|mp2)/)) {
				return 'audio'
			}

			if (ext.match(/(mp4|webm)/)) {
				return 'video'
			}

			if (ext.match(/(jpeg|jpg|gif|bmp|png)/)) {
				return 'imagen'
			}

			return 'desconocido'
		},

		url () {
			return '/src/modulos/produccion/php/api/descargar.php?ID_fichero=' + this.fichero.fichero.ID_fichero + '&tipo=' + this.fichero.tipo
		},

		tamano () {
			if (!this.fichero) {
				return '0 kB'
			}

			let bytes = this.fichero.fichero.tamano
			const si = true
			var thresh = si ? 1000 : 1024
			if (Math.abs(bytes) < thresh) {
				return bytes + ' B'
			}
			var units = si
				? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
				: ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
			var u = -1
			do {
				bytes /= thresh
				++u
			} while (Math.abs(bytes) >= thresh && u < units.length - 1)
			return bytes.toFixed(1) + ' ' + units[u]
		}
	},

	methods: {
		cerrar () {
			this.$emit('cerrar')
		}
	}
}
</script>




// WEBPACK FOOTER //
// src/modulos/produccion/vue/components/produccion/reproductor.vue